import { EnvironmentInerface } from "src/app/accountancy/utilities/interfaces/environment.interface";

export const environment: EnvironmentInerface = {
  baseURL: 'https://wpgxdzobxl.execute-api.ap-southeast-1.amazonaws.com/dev',
  hrisURL: 'https://axj5nn4c99.execute-api.ap-southeast-1.amazonaws.com/dev',
  hris2URL: 'https://ylhv7qjbji.execute-api.ap-southeast-1.amazonaws.com/dev',
  websiteURL: 'https://acctg.agf-security.com',
  production: false,
  version: '1.0.0-UAT',
  apiKey: '4DFKBLeweMaEMgGkT3NUe3g05rM8ASMf74aqx7N1',
};